import React, { useState, useContext, createContext } from "react";

// ** Utils Imports

const overlayContext = createContext();

export function ProviderOverlay({ children }) {
  const overlay = useProviderOverlay();
  return (
    <overlayContext.Provider value={overlay}>
      {children}
    </overlayContext.Provider>
  );
}

export const useOverlay = () => {
  return useContext(overlayContext);
};

function useProviderOverlay() {
  // ** State
  const [isOpenOverlay, setIsOpenOverlay] = useState(false);

  // Return State && SetState
  return {
    isOpenOverlay,
    setIsOpenOverlay
  };
}
